import React, { useEffect, useState } from 'react';

import {
  Grid,
  IconButton,
  Tooltip,
  Typography,
  makeStyles,
} from '@material-ui/core';
import IconInfo from '@material-ui/icons/InfoRounded';

import { useIsMobile } from '../../../hooks/useBreakpoints';

type Props = {
  label?: string;
  required?: boolean;
  tooltip?: string;
  icon?: React.ReactNode;
};

const useStyles = makeStyles(() => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  button: {
    padding: '0 4px',
  },
  tooltip: {
    minWidth: '360px',
    marginBottom: '10px',
    [`@media screen and (max-width:768px)`]: {
      minWidth: 'auto',
    },
  },
}));

const LabelWithTooltip: React.FC<Props> = (props) => {
  const {
    label,
    required,
    tooltip,
    icon = <IconInfo style={{ fontSize: '18px' }} />,
  } = props;

  const classes = useStyles();
  const isMobile = useIsMobile();
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  useEffect(() => {
    let timeout: NodeJS.Timeout;

    if (isMobile && isTooltipVisible) {
      timeout = setTimeout(() => setIsTooltipVisible(false), 2000);
    }

    return () => timeout && clearTimeout(timeout);
  }, [isMobile, isTooltipVisible]);

  return (
    <Grid item className={classes.wrapper}>
      {label}
      {tooltip && (
        <Tooltip
          classes={{ tooltip: classes.tooltip }}
          placement="top"
          arrow
          title={<Typography>{tooltip}</Typography>}
          open={isTooltipVisible}
          onClose={() => setIsTooltipVisible(false)}
        >
          <IconButton
            aria-label="info"
            className={classes.button}
            {...(isMobile
              ? {
                  onClick: () => setIsTooltipVisible(!isTooltipVisible),
                }
              : {
                  onMouseEnter: () => setIsTooltipVisible(true),
                  onMouseLeave: () => setIsTooltipVisible(false),
                })}
          >
            {tooltip && icon}
          </IconButton>
        </Tooltip>
      )}
      {required && <span className="label--required">*</span>}
    </Grid>
  );
};

export default LabelWithTooltip;
